import { Socket } from './index';

function SocketWrapper() {
    this.socket = new Socket();
    window.g_socket = this.socket;
    window._wrappedSocket = this;
}

SocketWrapper.prototype.connect = async function () {
    return new Promise((resolve, reject) => {
        this.socket.config.host = this.host;
        this.socket.config.username = this.walletApiUsername;
        this.socket.connect(error => error ? reject(error) : resolve());
    });
}

SocketWrapper.prototype.close = async function () {
    this.socket.socket.close();
}

SocketWrapper.prototype.login = async function (authParams) {
    if (authParams !== null) {
        this.socket.setAuthParams(authParams);
    }
    this.socket.isLogged = false;
    return new Promise((resolve, reject) => {
        this.socket.onConnectionBroken = () => {
            reject(new Error("Game Server disconnected during authentication"));
            this.socket.onConnectionBroken = () => { };
        }
        this.socket.loginSID((data) => {
            setTimeout(() => {
                if (!this.isConnected) {
                    return;
                }
                this.socket.onConnectionBroken = () => { };
                if (data.error) {
                    reject(data.error);
                } else {
                    this.socket.isLogged = true;
                    resolve(data);
                }
            }, 100);
        });
    });
}

SocketWrapper.prototype.getCurrencyCode = async function () {
    return new Promise((resolve, reject) => {
        this.socket.getCurrencyCode((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                resolve(data);
            }
        });
    });
}

SocketWrapper.prototype.getBalance = async function () {
    return new Promise((resolve, reject) => {
        const response = {};
        this.socket.getRealBalance((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                response.balance = data.balance;
                this.socket.getDenomination((data) => {
                    if (data.error) {
                        reject(data.error);
                    } else {
                        response.denomination = data.denomination;
                        response.depositBonus = data.depositBonus;
                        resolve(response);
                    }
                });
            }
        });
    });
}

SocketWrapper.prototype.syncBalance = async function () {
    return new Promise((resolve, reject) => {
        const response = {};
        this.socket.syncBalance((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                response.balance = data.balance;
                this.socket.getDenomination((data) => {
                    if (data.error) {
                        reject(data.error);
                    } else {
                        response.denomination = data.denomination;
                        response.depositBonus = data.depositBonus;
                        resolve(response);
                    }
                });
            }
        });
    });
}

SocketWrapper.prototype.getCashbackBonus = async function () {
    return new Promise((resolve, reject) => {
        const response = {};
        this.socket.getCashbackBonus((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                response.balance = data.balance;
                response.cashbackBonus = data.cashbackBonus;
                resolve(response);
            }
        });
    });
}

SocketWrapper.prototype.takeCashbackBonus = async function () {
    return new Promise((resolve, reject) => {
        const response = {};
        this.socket.takeCashbackBonus((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                resolve(response);
            }
        });
    });
}

SocketWrapper.prototype.getJackpots = async function () {
    return new Promise((resolve, reject) => {
        this.socket.getJackpotValue((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                resolve(data);
            }
        });
    });
}

SocketWrapper.prototype.setDenomination = async function (denomination) {
    return new Promise((resolve, reject) => {
        this.socket.setDenomination(denomination, (data) => {
            if (data.error) {
                reject(data.error);
            } else {
                resolve(denomination);
            }
        });
    });
}

SocketWrapper.prototype.exitGame = async function () {
    return new Promise((resolve, reject) => {
        const response = {};
        this.socket.exitGame((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                resolve(response);
            }
        });
    });
}

SocketWrapper.prototype.getBonusInfo = async function () {
    if (false) {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        this.socket.sendGetAvailableBonuses((data) => {
            if (data.error) {
                reject(data.error);
            } else {
                resolve(data);
            }
        });
    });
}

SocketWrapper.prototype.saveHandlers = function () {
    this.socket.saveHandlers();
}

SocketWrapper.prototype.restoreHandlers = function () {
    this.socket.restoreHandlers();
}

Object.defineProperty(SocketWrapper.prototype, 'isLoggedIn', {
    get: function () {
        return this.socket.isLogged;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'isConnected', {
    get: function () {
        return this.socket.connected;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'onDisconnect', {
    get: function () {
        return this.socket.onConnectionBroken;
    },
    set: function (value) {
        this.socket.onConnectionBroken = value;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'onChangeBalance', {
    set: function (value) {
        this.socket.onChangeBalance = value;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'onResetBalance', {
    set: function (value) {
        this.socket.onResetBalance = value;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'onPanic', {
    set: function (value) {
        this.socket.onPanic = value;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'onTournamentClosed', {
    set: function (value) {
        this.socket.onTournamentClosed = value;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'onBonusReceived', {
    set: function (value) {
        this.socket.onBonusReceived = value;
    }
});

Object.defineProperty(SocketWrapper.prototype, 'inGameMode', {
    set: function (value) {
        this.socket.inGameMode = value;
    }
});

export default SocketWrapper;